import { useState } from "react";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

export default function RangeInputSlider({ SliderValue, handleChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}>
      <span style={{ fontSize: "8px" }}>{SliderValue.min}</span>
      <RangeSlider onInput={handleChange} min={100} max={60000} />
      <span style={{ fontSize: "8px" }}>{SliderValue.max}</span>
    </div>
  );
}
